import classNames from 'classnames';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

import styles from './styles.module.scss';

export const AccordionItemWrapper = ({
  question,
  answer,
  hideLines,
  hideOnlyFirstLine,
  whiteAccordion,
  wrapperClassName,
  titleClassName,
  bodyClassName,
  buttonClassName,
  headingClassName,
  headerTopMargin,
  uuid,
  useBlueThemedAccordion,
  sectionHeaderLevel = 2,
  useV2Styles,
}) => {
  const SectionHeaderTag = `h${sectionHeaderLevel}`;
  return (
    <AccordionItem
      uuid={uuid}
      className={classNames(
        useBlueThemedAccordion ? 'new_accordion_item' : 'accordion__item',
        {
          [styles.hideLines]: hideLines,
          [styles.hideOnlyFirstLine]: hideOnlyFirstLine,
          [styles.whiteAccordion]: whiteAccordion,
        },
        wrapperClassName
      )}
    >
      <AccordionItemHeading
        className={classNames('accordion__heading', `${headingClassName}`, {
          [styles.itemHeading]: whiteAccordion || useBlueThemedAccordion,
          [styles.topMargin]: headerTopMargin,
        })}
      >
        <AccordionItemButton className={`${buttonClassName}`}>
          <SectionHeaderTag className={`u-position-relative font-up-2 ${titleClassName}`}>
            <div
              className={classNames(
                'accordion__arrow',
                useBlueThemedAccordion && 'new_accordion__arrow',
                useV2Styles && 'v2_arrow'
              )}
              role="presentation"
            />
            {question}
          </SectionHeaderTag>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemState>
        {({ expanded }) => (
          <AccordionItemPanel
            className={classNames(expanded ? 'accordion__panel' : 'accordion__panel--hidden', bodyClassName, {
              [styles.itemPanel]: whiteAccordion || useBlueThemedAccordion,
            })}
          >
            {answer}
          </AccordionItemPanel>
        )}
      </AccordionItemState>
    </AccordionItem>
  );
};
